import { render, staticRenderFns } from "./ReadAccounts.vue?vue&type=template&id=328ca181&"
import script from "./ReadAccounts.vue?vue&type=script&lang=js&"
export * from "./ReadAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports